var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-wrapper"},[_c('iframe',{attrs:{"src":_vm.videoUrl,"frameborder":"0","allow":"autoplay; fullscreen; picture-in-picture","allowfullscreen":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }